import * as React from "react";
import {
  styledContainer,
  styledModal,
  logo,
  genericLogo,
} from "./HotelSearchModal.module.scss";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

export const StyledModal: React.FC<any> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  return (
    <Modal
      backdrop={isMobileOnly ? false : true}
      {...props}
      className={styledModal}
    >
      {props.children}
    </Modal>
  );
};

export const StyledContainer: React.FC<any> = (props) => {
  return <Container className={styledContainer}>{props.children}</Container>;
};
export const Logo: React.FC = () => {
  return (
    <svg className={logo}>
      <use xlinkHref="/svg/sonesta_gray.svg#SonestaLogo"> </use>
    </svg>
  );
};
export const GenericLogo: React.FC<{ theme: { logo: string; alt: string } }> = (
  props
) => {
  return (
    <img src={props.theme.logo} alt={props.theme.alt} className={genericLogo} />
  );
};
